import React, { Component, PropTypes } from 'react';
import { get, merge } from 'lodash';
import FlatButton from '../../../../common/components/c_FlatButton';
import TextField from  '../../../../common/components/c_TextField';

const addButtonStyle = {
  style: {
	width: '70px',
	display: 'inline-block',
	transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1)',
	border: '0px ',
  },
  hoverStyle: {
    border: '0px',
  }
};

export default class DocumentItemView  extends Component {

	static propTypes = {
		data: PropTypes.object,
		onChange: PropTypes.func.isRequired,
		onRemove: PropTypes.func.isRequired,
	}

	constructor(props, context) {
		super(props, context);
	}

	render() {

		let {data, onRemove, onChange} = this.props || [];

		return (
			<div className='document-item-view'>
			<div className='document-item-view-filename'>
				<TextField
					data-id='document filename'
					disabled
					style={{width: 'calc(100% - 14px)'}}
					floatingLabelText='File Name'
					value={data.fileName}
					inputStyle={{
						textOverflow: 'ellipsis',
						maxWidth: '76%',
						color: '#777'
					}}
				/>
				<span className='megabyte-count'>
				{`${Math.max(Math.round(data.fileSize/100000)/10, 0.1)} Mgb`}
				</span>
				</div>

			<TextField
				data-id='document description'
				floatingLabelText='Description'
				value={data.description}
				inputStyle={{ fontSize: '14px' }}
				style={{width: 'calc(59% - 40px)'}}
				onChange={(e, value) => onChange(value, data) }
			/>

			<div className='remove-button-container'>
				<FlatButton {...addButtonStyle} onClick={e => onRemove(data) } label='Remove' />
			</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/DocumentItemView/index.js